import { __assign } from "tslib";
export function resolveUserAgentConfig(input) {
    return __assign(__assign({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/middleware-user-agent/dist-es/configurations.js
// module id = 712
// module chunks = 0